import { Action, ActionReducer } from '@ngrx/store';
import { ShopIdAction, ShopIdActionType } from '../../actionstypes/selected-id/shop-id.actiontype';

const initialState = -1;

const shopIdReducer = (state = initialState, action: ShopIdActionType): number => {
  switch (action.type) {
    case ShopIdAction.Set:
      return action.payload;

    case ShopIdAction.Reset:
      return -1;

    case ShopIdAction.Sync:
      if (state === -1) {
        return state;
      }

      if (!action.payload.includes(state)) {
        return -1;
      }

      return state;

    default:
      return state;
  }
};

export default shopIdReducer as ActionReducer<number, Action<string>>;
